import React, { useState } from 'react';
import './Module.css';
import '../../../components/public/demo/DemoPage.css';
import Network from '../../../models/Network.js';
import { VALIDATE_DEMO_CODE_URL } from '../../../urls.js';

const DemoLoginModule = ({ onLoginSuccess }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isValidating, setIsValidating] = useState(false);

    const handleLogin = async () => {
        setIsValidating(true);
        setError('');

        // First check if it's the hardcoded 'clapstone' code
        if (password === 'clapstone') {
            onLoginSuccess('demo agency');
            return;
        }

        // If not 'clapstone', validate against database
        const dict = {
            demo_code: password,
            CLIENT_ACCESS_KEY: process.env.REACT_APP_CLIENT_ACCESS_KEY
        };

        await Network.post(VALIDATE_DEMO_CODE_URL, dict, (response) => {
            setIsValidating(false);
            
            if (Network.checkValidStatusAndResponse(response)) {
                if (response.data.status === 'success') {
                    if (response.data.valid) {
                        // Use the code as the session agency
                        onLoginSuccess(password, response.data.code_data);
                    } else {
                        setError(response.data.message || 'Invalid access code');
                    }
                } else {
                    setError('Error validating access code. Please try again.');
                }
            } else {
                setError('Error validating access code. Please try again.');
            }
        });
    };

    return (
        <div className="standard-module">
            <div style={{ 
                margin: '0 auto', 
                maxWidth: '300px',
                width: '100%'
            }}>
                <div style={{
                    marginBottom: '15px',
                    position: 'relative'
                }}>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter demo access code"
                        disabled={isValidating}
                        style={{ 
                            width: '100%',
                            padding: '12px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: '14px',
                            boxSizing: 'border-box',
                            backgroundColor: isValidating ? '#f5f5f5' : 'white'
                        }}
                    />
                </div>
                {error && (
                    <p style={{ 
                        color: '#dc3545', 
                        marginBottom: '15px',
                        fontSize: '14px',
                        textAlign: 'center'
                    }}>
                        {error}
                    </p>
                )}
                {isValidating && (
                    <p style={{ 
                        color: '#666', 
                        marginBottom: '15px',
                        fontSize: '14px',
                        textAlign: 'center'
                    }}>
                        Validating access code...
                    </p>
                )}
                <button 
                    className="demo-login-btn"
                    onClick={handleLogin}
                    disabled={isValidating}
                    style={{
                        opacity: isValidating ? 0.6 : 1,
                        cursor: isValidating ? 'not-allowed' : 'pointer'
                    }}
                >
                    {isValidating ? 'Validating...' : 'Submit'}
                </button>
                <p style={{ 
                    marginTop: '15px',
                    fontSize: '12px',
                    textAlign: 'center',
                    color: '#666'
                }}>
                    If you do not have a demo code, reach out to us{' '}
                    <a 
                        href="mailto:brad@cadmusanalytics.com"
                        style={{
                            color: 'var(--red)',
                            textDecoration: 'none'
                        }}
                    >
                        here
                    </a>
                    {' '}with your name and affiliation
                </p>
            </div>
        </div>
    );
};

export default DemoLoginModule; 